// src/pages/BetaExpired.tsx
import { CONTACT } from '../constants/config';
import { useTheme } from '../context/ThemeContext';
import { colors } from '../utils/theme';

const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'TryQuiPus';
const WA_URL = CONTACT.WA_URL;

export default function BetaExpired() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const c = colors(isDark);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: c.canvas }}>
      <div className="w-full max-w-md text-center">
        {/* Logo */}
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-cyan-400 mb-6 shadow-lg shadow-cyan-500/25">
          <span className="text-2xl font-black text-white">Q</span>
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-bold tracking-tight mb-2" style={{ color: c.textPrimary }}>
          Tu acceso beta ha expirado
        </h1>
        <p className="text-base font-medium mb-6" style={{ color: c.info }}>
          Gracias por probar {APP_NAME} 🙏
        </p>

        {/* Card */}
        <div className="rounded-2xl px-8 py-7 shadow-2xl mb-6"
          style={{ background: c.card, border: `1px solid ${c.border}` }}>
          <p className="text-sm leading-relaxed" style={{ color: c.textNormal }}>
            Tu período de evaluación ha terminado. Para continuar usando TryQuiPus, contáctanos.
          </p>
        </div>

        {/* CTA */}
        <a
          href={WA_URL}
          target="_blank"
          rel="noreferrer"
          className="btn is-stuck inline-flex items-center justify-center w-full py-3.5 rounded-xl font-bold text-sm"
        >
          {/* WhatsApp icon */}
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
          Contactar por WhatsApp
        </a>

        <p className="text-xs mt-5" style={{ color: c.textMuted }}>
          ¿Ya eres cliente? Escríbenos y activamos tu cuenta.
        </p>

        <p className="t-2xs mt-6" style={{ color: c.textMuted, opacity: 0.7 }}>
          {APP_NAME} · Software Contable para Perú
        </p>
      </div>
    </div>
  );
}
